export const LOAD_METER_ZIP_UPLOAD_HISTORY= 'LOAD_METER_ZIP_UPLOAD_HISTORY';
export const NO_DATA_FOUND ="No Data Found";
export const UPLOAD_METER_ZIP_REQUEST = "UPLOAD_METER_ZIP_REQUEST";
export const UPLOAD_METER_ZIP_SUCCESS = "UPLOAD_METER_ZIP_SUCCESS";
export const GENERIC_MESSAGE = "Failed due to a technical error, please try again later";
export const GENERIC_FAILED_ERROR ="Connection timed out. Please try again after some time.";
export const METER_ZIP_UPLOAD_ERROR = "METER_ZIP_UPLOAD_ERROR";
export const CLOSE_SUCCESS_MESSAGE_POPUP = "CLOSE_SUCCESS_MESSAGE_POPUP";
export const CLOSE_ERROR_MESSAGE_POPUP = "CLOSE_ERROR_MESSAGE_POPUP";
export const LOAD_METER_MODEL_LIST = "LOAD_METER_MODEL_LIST";
export const LOAD_METER_HISTORY_REQUEST = "LOAD_METER_HISTORY_REQUEST";
export const LOAD_METER_HISTORY_SUCCESS = "LOAD_METER_HISTORY_SUCCESS";
export const LOAD_METER_HISTORY_FILTERS_SUCCESS = "LOAD_METER_HISTORY_FILTERS_SUCCESS";
export const LOAD_METER_HISTORY_ERROR = "LOAD_METER_HISTORY_ERROR";
export const EMPTY_METER_ZIP_UPLOAD_HISTORY = "EMPTY_METER_ZIP_UPLOAD_HISTORY";
export const METER_UPLOAD_INSTANCE_LIST_AND_ZIP_SIZE_LIMIT = "METER_UPLOAD_INSTANCE_LIST_AND_ZIP_SIZE_LIMIT";
export const ZIP_LENGTH = 30;
export const METERING_DATE_TIME_FORMAT = "DD MMM YYYY HH:mm:ss";
export const OPEN_ERROR_MESSAGE_POPUP_FILE_SIZE = "OPEN_ERROR_MESSAGE_POPUP_FILE_SIZE";
export const OPEN_ERROR_MESSAGE_POPUP_FILE_TYPE = "OPEN_ERROR_MESSAGE_POPUP_FILE_TYPE";
export const ZIP_FILE_TYPE = "application/x-zip-compressed";
